export default __webpack_public_path__ + "static/media/dungeon-waifu.87fcbe9c.png";